// Define API base URL that will be used throughout the application
// We access it via import.meta.env in runtime
export const API_BASE_URL_KEY = 'API_BASE_URL'

// Base URL placeholders for different API services - available for advanced routing
export const BASE_URL_PLACEHOLDER = {
  MAIN_API: `{{${API_BASE_URL_KEY}}}`,
}

// Headers
export const HEADERS = {
  NO_CACHE: 'x-no-cache',
}

// API endpoint constants following the flat structure approach
export const ENDPOINTS = {
  // Authentication endpoints
  LOGIN: '/login',

  // Landing page endpoints
  TEAMS_LIST_PAGE_FILTER: '/dashboard/page/filter',
  PROGRAMS_LIST_PAGE_FILTER: '/productDashboards/page/filter',
  LANDING_PAGE_AGGREGATED_VIEW: '/landing-page/aggregated-view',
  LANDING_PAGE_TREE_VIEW: '/landing-page/tree-view',
  LANDING_PAGE_PROGRAM_WISE_DATA: '/landing-page/program-wise-data',
  LANDING_PAGE_TRENDS_TAB: '/landing-page/trends-tab',

  // Endpoint for fetching all product dashboards (no /page/filter)
  PRODUCT_DASHBOARDS_LIST: '/productDashboards/',

  // Endpoint for fetching all programs for dropdown (without pagination)
  ALL_PROGRAMS_LIST: '/productDashboards/all-info',

  // SE Metrics endpoints
  SE_METRICS_V2: '/se-metrics/v2',
  SE_METRICS_BY_PERIOD_RANGE: '/se-metrics/by-period-range',
  SE_METRICS_LIST_BY_PERIOD: '/se-metrics/list-by-period',
  SE_MANUAL_METRICS: '/se-metrics/manual',
  SE_MANUAL_FEATURE_DELIVERY: '/se-metrics/manual/feature-delivery',
  SE_MANUAL_FEATURE_DELIVERY_TRENDS: '/se-metrics/feature-delivery/trends',
  SE_METRICS_REPORT: 'productDashboards/configurations/se-metrics/reports',
  SE_METRICS_ALL_REPORTS: '/productDashboards/configurations/se-metrics/all-reports',
  SE_METRICS_DATA_VALIDATION_WINDOW: '/se-metrics/data-validation-window',
  POWER_BI_REPORT: 'powerBiView',

  // Code Repository endpoints
  FETCH_COMMITS: `/commit/`,
  FETCH_COMMITS_IN_WEEKS: `/commit/bydays/filter`,
  FETCH_COMMIT_COUNT: `/commit/count`,
  FETCH_PULL_REQUESTS: `/gitrequests/type/pull/state/all`,
  FETCH_PULL_REQUESTS_IN_WEEKS: `/gitrequests/bydays/filter`,
  FETCH_PULL_REQUESTS_COUNT: `/gitrequests/type/pull/state/all/count`,

  // Build & Deploy tab Endpoints
  DEPLOYMENT_STATUS_BY_DATE: `/deploy/status/bydate`,
  BUILD_DATA: `/build`,
  BUILD_DEPLOY_GT_METRICS_TEAM: `/deploy/gt-metrics`,

  // Dashboard endpoint
  DASHBOARD_BY_ID: '/dashboard/',
  TEAM_DASHBOARDS_LIST: '/dashboard/basic',

  // Feature tab endpoints
  SPRINT_METRICS: '/sprintMetrics/onTimeDeliveryMetrics',
  ITERATION_SUMMARY: '/iteration',
  FEATURE_WIP: '/feature/wip',
  AGGREGATE_SPRINT_ESTIMATES: '/sprint/estimates/aggregate',

  // QA Metrics endpoints
  DEFECT_DENSITY: '/sprintMetrics/defectDensity',

  // Static Code Analysis endpoints
  COLLECTOR_ITEM_ENDPOINT: '/collector/item/component',
  STATIC_CODE_ANALYSIS: '/ui-widget/code-quality',

  // AppSec Flow endpoint
  APPSEC_FLOW_ENDPOINT: '/appsecflow/metrics',
  // Transition Alert endpoint (Edit Status Side Panel)
  TRANSITION_ALERT: '/se-metrics/alert',
  TEST_AUTOMATION: '/sprintMetrics/testAutomation',
  AUTOMATION_EFFICIENCY: '/sprintMetrics/automationEfficiency',
  QA_BUGS_PER_DAY: '/qualityassurance/bugs',
  BUGS_PER_SEVERITY: '/qualityassurance/bugs/severity',
  TEST_SUITES_API: '/qualityassurance/testPlan',
  AUTOMATION_BUILD: '/qualityassurance/builds',

  // Sprint-wise velocity endpoint
  SPRINT_WISE_VELOCITY: '/velocity',

  // AI Productivity Metrics endpoint
  AI_PRODUCTIVITY_METRICS: '/sprintMetrics/ai-productivity/metrics',
  AI_PRODUCTIVITY_BUG_METRICS: '/sprintMetrics/ai-productivity/bug-metrics',

  // QA Metrics (Program Dashboard) endpoints
  BUGS_DATA: 'productDashboards/bugs/',
  BUGS_SEVERITY: 'productDashboards/bugs/severity',
  ESCAPE_DEFECTS: '/escape-defects',
  TEST_PLAN: 'productDashboards/testPlan',
  BUILDS: 'productDashboards/builds/',

  COMMITS: 'productDashboards/commit',
  PULL_REQUESTS: 'productDashboards/gitrequests/type/pull/state/all',
  COMMITS_COUNT: 'productDashboards/commit/count',
  PULL_REQUESTS_COUNT: 'productDashboards/gitrequests/type/pull/state/all/count',
  TEST_AUTOMATION_PRODUCT: '/productDashboards/sprintMetrics/testAutomation',
  AUTOMATION_EFFICIENCY_PRODUCT: '/productDashboards/sprintMetrics/automationEfficiency',

  // Build & Deploy tab Endpoints
  BUILDS_PROGRAM: '/productDashboards/build',
  DEPLOYMENT_PROGRAM: '/productDashboards/deploy',
  BUILD_DEPLOY_GT_METRICS: '/productDashboards/deploy/gt-metrics',
  // Feature tab (Program Dashboard) endpoints
  ON_TIME_DELIVERY_DATA: '/productDashboards/sprintMetrics/onTimeDeliveryMetrics/',
  VELOCITY: '/productDashboards/velocity',
  DEFECT_AGING_DATA: '/productDashboards/defectAging/',
  // Code Analysis tab Endpoints
  SE_CODE_QUALITY_API: 'productDashboards/se-metrics/code-quality/',
  APPSEC_FLOW_PROGRAM: 'productDashboards/appsecflow/metrics',
  APPSEC_FLOW_CONFIGURATIONS: 'productDashboards/configurations/appsecflow',
  CODE_QUALITY_API: 'productDashboards/code-quality/',

  // User endpoints
  GET_USER: '/users/user',
  UPDATE_THEME: '/users/updateTheme',
  UPDATE_USER_SETTINGS: '/users',
  USER_HIERARCHY: '/users/hierarchy',
  // Favorites endpoints - userId will be appended dynamically
  ADD_FAVORITE: '/users/{userId}/favourites',
  DELETE_FAVORITE: '/users/{userId}/favourites',
  //cost
  AZURE_CLOUD_COST_OVERALL: '/azure-cloud-cost/overall',
  CLOUD_COST_SERVICES: '/cloudcost-service',
  CLOUD_COST_CONFIG: '/cloudcost-config',

  // AI Metrics endpoints
  AI_METRICS: '/productDashboards/ai-productivity/metrics',
  AI_METRICS_BUG: '/productDashboards/bug-ai-productivity/metrics',
  AI_PRODUCTIVITY_HIERARCHICAL: '/agentic-analytics/v2/hierarchical',
  AI_PRODUCTIVITY_HIERARCHICAL_V1: '/agentic-analytics/hierarchical',
  AI_USER_SEARCH: '/agentic-analytics/user-search',
  AI_INACTIVE_USERS_REPORT: '/agentic-analytics/inactive-users',
  AI_AGENTIC_ANALYTICS: '/agentic-analytics',
  AI_LOC_BENCHMARK: '/agentic-analytics/v2/ai-loc-benchmark',
  AI_LOC_BENCHMARK_V1: '/agentic-analytics/ai-loc-benchmark',
  AI_PRODUCTIVITY_MONTHLY_TREND_RANGE: '/agentic-analytics/v2/monthly-trend-range',
  AI_PRODUCTIVITY_MONTHLY_TREND_RANGE_V1: '/agentic-analytics/monthly-trend-range',
  AI_PRODUCTIVITY_INACTIVE_USERS: '/agentic-analytics/inactive-users',
  AI_PRODUCTIVITY_REPORTEES: '/agentic-analytics/hierarchical/reportees',
  AI_PERFORMER: '/agentic-analytics/v2/ai-performer',
  AI_PERFORMER_V1: '/agentic-analytics/ai-performer',
  AI_CREDIT_USAGE_MONTHLY_TREND: '/agentic-analytics/v2/credit-usage-monthly-trend',
  AI_CREDIT_USAGE_MONTHLY_TREND_V1: '/agentic-analytics/credit-usage-monthly-trend',
  AI_LOC_USAGE_MONTHLY_TREND: '/agentic-analytics/v2/loc-usage-monthly-trend',
  AI_LOC_USAGE_MONTHLY_TREND_V1: '/agentic-analytics/loc-usage-monthly-trend',
  AI_PRODUCTIVITY_CREDIT_USAGE: '/agentic-analytics/credit-usage',
  COMMIT_METRICS: '/agentic-analytics/commit-metrics',
  // Vendor Analysis endpoints
  VENDOR_TEAM_OVERVIEW: '/agentic-analytics/users/:email/team-overview',
  VENDOR_TEAM_OVERVIEW_DOWNLOAD: '/agentic-analytics/users/:email/team-overview/download',
  VENDOR_LEADER_ADOPTION_SUMMARY: '/agentic-analytics/leader-team-adoption-summary',
  VENDOR_USER_ACTIVITY_REPORT: '/agentic-analytics/user-activity-report',
  // SE Metrics Overall endpoint
  SE_METRICS_OVERALL: '/se-metrics/overall',

  // Programs endpoint
  PROGRAMS: '/programs',

  // Agile Metrics endpoints
  AGILE_PROGRAMS_SUMMARY: '/dai/programs/summary',
  AGILE_ALL_PROGRAMS: '/dai/all/programs',

  // Programs and Configurations endpoints
  PROGRAMS_CONFIG_FILTERS: '/productDashboards/configurations/se-metrics/missing-config-filter',
  PROGRAMS_CONFIG_REPORT: '/productDashboards/configurations/se-metrics/missing-config-report',
  PROGRAMS_CONFIG_ESTIMATION: '/productDashboards/configurations/{id}/missing-config-estimation',

  // Trends View tab endpoints
  TRENDS_METRICS: '/metrics-trends',
  TRENDS_PR_METRICS: '/metrics-trends/pr-metrics',
  TRENDS_REPOSITORY_COMMITS: '/metrics-trends/repository-metrics/commits',
  TRENDS_PROGRAM_USER_ACTIVITY: '/metrics-trends/program-user-activity',
  TRENDS_PR_THROUGHPUT_ACTIVE_COMMITTERS: '/metrics-trends/pr-throughput-active-committers',

  // Access Delegations endpoints
  ACCESS_DELEGATIONS: '/access-delegations',
  ACCESS_DELEGATIONS_AUDIT: '/access-delegations/audit',
  ACCESS_DELEGATIONS_CANDIDATES: '/access-delegations/candidates',
  ACCESS_DELEGATIONS_REVOKE: '/access-delegations/revoke',
  ACCESS_DELEGATIONS_SUMMARY: '/access-delegations/access-summary',

  // DPA Reports endpoints
  FETCH_DPA_REPORTS: '/fetch-dpa-reports',

  // AI Productivity Report endpoints
  FETCH_AI_REPORT_ADOPTION_HEALTH: '/fetch-ai-productivity-reports/adoption-health',
  FETCH_AI_REPORT_AI_ADOPTION: '/fetch-ai-productivity-reports/ai-adoption',
  FETCH_AI_REPORT_AI_TOOL_PERFORMANCE: '/fetch-ai-productivity-reports/ai-tool-performance',
  FETCH_AI_REPORT_CREDIT_OVERVIEW: '/fetch-ai-productivity-reports/credit-overview',
  FETCH_AI_REPORT_PULL_REQUEST_METRICS: '/fetch-ai-productivity-reports/pull-request-metrics',
  FETCH_AI_REPORT_COMMIT_ANALYTICS: '/fetch-ai-productivity-reports/commit-analytics-overview',
  FETCH_AI_REPORT_EXPORT_EXCEL: '/fetch-ai-productivity-reports/export-excel',

  // Program Insights endpoints
  PROGRAM_INSIGHTS_L1_LEADERS: '/program-insights/l1-leaders',
  PROGRAM_INSIGHTS_ENGINEERING_MANAGERS: '/program-insights/engineering-managers',
  PROGRAM_INSIGHTS_PROGRAMS: '/program-insights/programs',
  PROGRAM_INSIGHTS_PR_METRICS: '/program-insights/pr-metrics',
  PROGRAM_INSIGHTS_STORY_POINTS_SAVED: '/program-insights/story-points-saved',
  PROGRAM_INSIGHTS_LEADERSHIP_SUMMARY: '/program-insights/leadership-summary',
  PROGRAM_INSIGHTS_LEADERSHIP_TRENDS: '/program-insights/leadership-trends',
  PROGRAM_INSIGHTS_APP_OWNERS: '/program-insights/app-owners',

  // People Assignment endpoints — paths relative to the people-assignment base
  // (`API_BASE_URL/people-assignment`, overridable via VITE_PEOPLE_ASSIGNMENT_BASE_URL).
  // `{allocationId}` is replaced at call time.
  PEOPLE_ASSIGNMENT: {
    EMPLOYEES: '/employees',
    ASSIGNMENTS: '/assignments',
    ALLOCATIONS: '/allocations',
    BULK_ALLOCATIONS: '/bulk-allocations',
    SUBMITTED_REQUESTS: '/requests/submitted',
    PENDING_APPROVALS: '/requests/pending-approvals',
    APPROVE_REQUEST: '/requests/{allocationId}/approve',
    REJECT_REQUEST: '/requests/{allocationId}/reject',
    CANCEL_REQUEST: '/requests/{allocationId}/cancel',
    AUDIT: '/audit',
    PROGRAMS: '/programs',
  },
  // Product Dashboards — cascading filter endpoints
  PRODUCT_DASHBOARDS_L1_LEADER_EMAILS: '/productDashboards/l1LeaderEmails',
  PRODUCT_DASHBOARDS_APP_OWNER_EMAILS: '/productDashboards/appOwnerEmails',
  PRODUCT_DASHBOARDS_BY_LEADER_EMAILS: '/productDashboards/byLeaderEmails',

  // Automation WIQL validation
  AUTOMATION_WIQL_VALIDATE: '/ado/automation-wiql/validate',

  // User Preferences endpoints (table settings)
  // POST: /users/{userId}/se-metrics/table-settings
  USER_TABLE_SETTINGS: '/users/{userId}/se-metrics/table-settings',
}
// Export API endpoints
export const API_ENDPOINTS = ENDPOINTS
